/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1Message
 */
export interface V1Message {
    /**
     *
     */
    id?: string
    /**
     *
     */
    requestId?: string
    /**
     *
     */
    senderId?: string
    /**
     *
     */
    recipientId?: string
    /**
     *
     */
    text?: string
    /**
     *
     */
    createdAt?: number
}

/**
 * Check if a given object implements the V1Message interface.
 */
export function instanceOfV1Message(value: object): value is V1Message {
    return true
}

export function V1MessageFromJSON(json: any): V1Message {
    return V1MessageFromJSONTyped(json, false)
}

export function V1MessageFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1Message {
    if (json == null) {
        return json
    }
    return {
        id: json['id'] == null ? undefined : json['id'],
        requestId: json['requestId'] == null ? undefined : json['requestId'],
        senderId: json['senderId'] == null ? undefined : json['senderId'],
        recipientId:
            json['recipientId'] == null ? undefined : json['recipientId'],
        text: json['text'] == null ? undefined : json['text'],
        createdAt: json['createdAt'] == null ? undefined : json['createdAt']
    }
}

export function V1MessageToJSON(json: any): V1Message {
    return V1MessageToJSONTyped(json, false)
}

export function V1MessageToJSONTyped(
    value?: V1Message | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        id: value['id'],
        requestId: value['requestId'],
        senderId: value['senderId'],
        recipientId: value['recipientId'],
        text: value['text'],
        createdAt: value['createdAt']
    }
}
